export default __webpack_public_path__ + "static/media/splash.40fc9e74.webp";